import { render, staticRenderFns } from "./PPersonalizeTable.vue?vue&type=template&id=614ad9ac&scoped=true&"
import script from "./PPersonalizeTable.vue?vue&type=script&lang=ts&"
export * from "./PPersonalizeTable.vue?vue&type=script&lang=ts&"
import style0 from "./PPersonalizeTable.vue?vue&type=style&index=0&id=614ad9ac&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "614ad9ac",
  null
  
)

export default component.exports